import React, { useState, useEffect } from "react";
import "../../styles/Funding.css";

const allCoins = [
  { name: "Bitcoin", symbol: "BTC", logo: "https://cryptologos.cc/logos/bitcoin-btc-logo.png" },
  { name: "USDT TRC20", symbol: "USDT", logo: "https://cryptologos.cc/logos/tether-usdt-logo.png" },
  { name: "Ethereum", symbol: "ETH", logo: "https://cryptologos.cc/logos/ethereum-eth-logo.png" },
];

const generateWalletAddress = (symbol) => {
  switch (symbol) {
    case "BTC":
      const btcStart = Math.random() > 0.5 ? "bc1" : "1";
      const btcChars = "0123456789abcdef";
      let btcAddr = btcStart;
      const btcLen = btcStart === "bc1" ? 42 : 34;
      for (let i = btcStart.length; i < btcLen; i++) {
        btcAddr += btcChars[Math.floor(Math.random() * btcChars.length)];
      }
      return btcAddr;
    case "ETH":
      const hexChars = "0123456789abcdef";
      let ethAddr = "0x";
      for (let i = 0; i < 40; i++) {
        ethAddr += hexChars[Math.floor(Math.random() * hexChars.length)];
      }
      return ethAddr;
    case "USDT":
      const trcChars = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
      let trcAddr = "T";
      for (let i = 0; i < 33; i++) {
        trcAddr += trcChars[Math.floor(Math.random() * trcChars.length)];
      }
      return trcAddr;
    default:
      return "0x" + Array(40).fill(0).map(() => 
        "0123456789abcdef"[Math.floor(Math.random() * 16)]
      ).join("");
  }
};

const truncateAddress = (address) => {
  return `${address.slice(0, 14)}...${address.slice(-5)}`;
};

const getRandomCoin = () => {
  const coin = allCoins[Math.floor(Math.random() * allCoins.length)];
  const amount = (Math.random() * 10000).toFixed(2);
  return { 
    ...coin, 
    wallet: generateWalletAddress(coin.symbol),
    amount: parseFloat(amount)
  };
};

const Funding = () => {
  const [coins, setCoins] = useState(() => {
    const initial = [];
    for (let i = 0; i < 14; i++) {
      initial.push({ ...getRandomCoin(), timestamp: Date.now() - (i * 3000), uniqueKey: i });
    }
    return initial;
  });

  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCoins((prevCoins) => {
        const newCoin = { ...getRandomCoin(), timestamp: Date.now(), uniqueKey: Date.now() };
        return [newCoin, ...prevCoins.slice(0, 13)];
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const getTimeAgo = (timestamp) => {
    const seconds = Math.floor((now - timestamp) / 1000);
    if (seconds < 60) {
      return `${seconds}secs ago`;
    }
    return `${Math.floor(seconds / 60)}mins ago`;
  };

  return (
  <div>
      <div className="funding-container">
        <div className="funding-header">
          <h3 className="funding-title">Live Payout and Deposit Transactions</h3>
          <p className="funding-subtitle">Real-time wallet transaction feed in USD across BTC, ETH, and USDT.</p>
        </div>
        
        <div className="funding-list">
          {coins.map((coin, index) => (
            <div key={coin.uniqueKey} className={`funding-item ${index < 2 ? 'recent' : ''}`}>
              <div className="funding-col-assets">
                <img src={coin.logo} alt={coin.name} className="funding-logo" />
                <span className="funding-name">{coin.name}</span>
              </div>
              <span className="funding-wallet">{truncateAddress(coin.wallet)}</span>
              <span className="funding-amount">${coin.amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              <span className="funding-badge">Completed {getTimeAgo(coin.timestamp)}</span>
            </div>
          ))}
        </div>
      </div>
  </div>
  );
};

export default Funding;